export var APLUS_LOGKEY = "/cnux.1.0";
export var APLUS_HOST = "gm.mmstat.com";
export var APLUS_URL = "https://".concat(APLUS_HOST).concat(APLUS_LOGKEY);
export var COOKIE_UID_KEY = "arms_uid";
export var COOKIE_UID_MAXAGE = 15552000;
export var PREF_APLUS_LOGKEY = "/cnux.1.0";
export var PREF_APLUS_URL = "".concat(APLUS_HOST).concat(PREF_APLUS_LOGKEY);
export var VALUE_LIMIT = 512;
